














import Vue from 'vue'
import Component from 'vue-class-component'

// We declare the props separately
// to make props types inferable.
const AppProps = Vue.extend({
  props: {
    iconName: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    }
  }
})

    @Component({})
export default class IconBase extends AppProps {
  // created () {
  //   console.log(this.$props)
  //   console.log('Firing!')
  // }
}
